import apiService from "@/api-service";
import { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { BestekUploader as Uploader } from './uploader';

interface Props {
    show: boolean;
    handleClose: () => void;
}

export default function BestekUploader(props: Props): JSX.Element {
    const allowed_extensions: string[] = ["rsx"];

    let tempSelectedFiles: FileSystemFileHandle[] = [];
    const [ selectedFiles, setSelectedFiles ] = useState<FileSystemFileHandle[]>([]);
    const [ uploaderBusy, setUploaderBusy ] = useState<boolean>(false);
    const [ uploader, setUploader ] = useState<Uploader>(new Uploader());

    const handleFolder = async (folder: FileSystemDirectoryHandle): Promise<void> => {
        // @ts-ignore
        for await(let entry of folder.values()) {
            if (entry.kind === "file") {
                const filename_split = entry.name.split(".");
                const ext = filename_split[filename_split.length - 1];
                if (allowed_extensions.includes(ext.toLowerCase())) {
                    // if (tempSelectedFiles.find(sf => sf.isSameEntry(entry)) === undefined) {
                        tempSelectedFiles.push(entry);
                    // }
                }
            } else if (entry.kind === "directory") {
                handleFolder(entry);
            }
        }
    }

    const selectFiles = async (): Promise<void> => {
        const pickerOpts = {
            types: [
                {
                    description: "RSX bestanden",
                    accept: {
                        "application/xml": allowed_extensions.map(ext => `.${ext}`),
                    },
                },
            ],
            excludeAcceptAllOption: true,
            multiple: true,
        };

        try {
            // @ts-ignore
            let handle: FileSystemFileHandle[] = await window.showOpenFilePicker(pickerOpts);

            setSelectedFiles([ ... selectedFiles, ... handle ]);
        } catch (e) {
            // @ts-ignore
            if (e instanceof AbortError) {

            } else {
                alert("Er is iets fout gegaan. Waarschijnlijk wordt de uploadfunctie niet ondersteund door uw browser. Momenteel worden alleen Chrome en Edge ondersteund.");
            }
        }
    }

    const selectFolder = async (): Promise<void> => {
        try {
            // @ts-ignore
            let handle: FileSystemDirectoryHandle = await window.showDirectoryPicker()
                    
            await handleFolder(handle);

            setSelectedFiles([ ... selectedFiles, ... tempSelectedFiles ]);
        } catch (e) {
            // @ts-ignore
            if (e instanceof AbortError) {

            } else {
                alert("Er is iets fout gegaan. Waarschijnlijk wordt de uploadfunctie niet ondersteund door uw browser. Momenteel worden alleen Chrome en Edge ondersteund.");
            }
        }
    }

    const upload = (): void => {
        uploader.setFiles(selectedFiles);
        uploader.upload();
        setUploaderBusy(true);
    }

    const handleClose = (): void => {
        if (uploader.isBusy()) {
            alert("Er worden momenteel bestanden geupload. Onderbreek eerst het upload proces om te sluiten.")
        } else {
            props.handleClose();
        }
    }

    useEffect(() => {
        let interval: NodeJS.Timer;

        if (uploaderBusy) {
            interval = setInterval(() => {
                if (!uploader.isBusy()) {
                    setUploaderBusy(false);
                }
            }, 1000);
        }

        return () => {
            clearInterval(interval);
        }
    })

    return (
        <Modal show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Bestekken uploaden</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex flex-column justify-content-center align-items-center">
                {
                    (uploader.didFinish() || uploader.wasCancelled()) && (
                        <>
                            <p style={{color: 'green', textAlign: 'center'}}>{uploader.acceptedFilesCount()} bestanden geaccepteerd. Het kan enkele minuten per bestand duren voordat deze volledig verwerkt zijn.</p>
                            <p style={{color: 'red', textAlign: 'center'}}>{uploader.declinedFilesCount()} bestanden niet geaccepteerd.</p>
                        </>
                    )
                }
                {
                    uploaderBusy && (
                        <>
                            <Spinner></Spinner>
                            <p>Bestanden worden geupload...</p>
                            <Button className="mt-2" onClick={uploader.stop.bind(uploader)}>Onderbreek uploadproces</Button>
                        </>
                    )
                }

                {
                    !uploaderBusy && (
                        <>
                            <p>{selectedFiles.length} bestanden geselecteerd.</p>
                            <Button onClick={selectFiles} className="mb-2">Selecteer bestand(en)</Button>
                            <Button onClick={selectFolder}>Selecteer map</Button>
                        </>
                    )
                }
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Sluiten
                </Button>
                <Button variant="primary" onClick={upload} disabled={selectedFiles.length === 0}>
                    Upload
                </Button>
            </Modal.Footer>
        </Modal>
    )
}